module.exports = __webpack_public_path__ + "static/media/icons.35545994.svg";